import { render, staticRenderFns } from "./LayoutBlank.vue?vue&type=template&id=62b5f006&scoped=true"
import script from "./LayoutBlank.vue?vue&type=script&lang=js"
export * from "./LayoutBlank.vue?vue&type=script&lang=js"
import style0 from "./LayoutBlank.vue?vue&type=style&index=0&id=62b5f006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5f006",
  null
  
)

export default component.exports